import React, { useEffect, createElement } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HomePage } from './pages/HomePage';
import { DocsPage } from './pages/DocsPage';
import { DocsPrinciplesPage } from './pages/DocsPrinciplesPage';
import { DocsModelsPage } from './pages/DocsModelsPage';
import { ModelsPage } from './pages/ModelsPage';
export function App() {
  useEffect(() => {
    document.title = 'OpenFPGA — The Unified Interface for FPGA Inference';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Better latency, better power efficiency, no vendor lock-in. Access the world's most powerful programmable hardware through a single API.";
    const ogTags: Record<string, string> = {
      'og:title': 'OpenFPGA — The Unified Interface for FPGA Inference',
      'og:description': "Better latency, better power efficiency, no vendor lock-in. Access the world's most powerful programmable hardware through a single API.",
      'og:type': 'website',
      'og:url': 'https://openfpga.ai',
      'og:site_name': 'OpenFPGA'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <HashRouter data-id="element-0">
      <div className="min-h-screen bg-gate-dark text-gate-text-primary font-sans selection:bg-gate-teal/30 selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/models" element={<ModelsPage data-id="element-7" />} data-id="element-6" />
          <Route path="/docs" element={<DocsPage data-id="element-9" />} data-id="element-8" />
          <Route path="/docs/principles" element={<DocsPrinciplesPage data-id="element-11" />} data-id="element-10" />
          <Route path="/docs/models" element={<DocsModelsPage data-id="element-13" />} data-id="element-12" />
        </Routes>
      </div>
    </HashRouter>;
}